import { Tooth } from '@/shared/api/protocol-ts/model/dto_report_tooth_pb';

export const toothHasReportID = (reportID: string) => (tooth: Tooth) =>
  tooth.ReportID === reportID;
